import {categoryDetails as service1}  from "@/content/services/1";
import {MetaTags} from "@/lib";
import {SubCategory} from "@/types";
import ServiceCategoryRow from "@/ui/service-category-row/service-category-row";
import LocalBusinessSeo from "@/lib/seo/local-business-seo";
import ContactSnippet from "@/ui/contact-snippet/contact-snippet";
import React from "react";
export default function Service1Page() {

    return (<>
            <LocalBusinessSeo />
            <MetaTags metaTags={service1.metaTags} />
            {service1?.subCategories?.length && service1?.subCategories?.map((category: SubCategory, i: number) =>  <ServiceCategoryRow
                    category={category}
                    alternate={i % 2 === 0}
                    i={i}
                    key={category.id}
                    showPoints
                />)}
            <ContactSnippet title={`Need more information on ${service1.name} services?`}
                            contactButtonText='Email us with your enquiries'
                            showContactButton
                            showContactInformation
            />
        </>
    )
}
